import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs';
import { AutoMlService } from 'src/app/core/service/auto-ml.service';

@Component({
  selector: 'app-automl-login',
  templateUrl: './automl-login.component.html',
  styleUrls: ['./automl-login.component.scss']
})
export class AutomlLoginComponent {
  isLoading:boolean=false;
  constructor(
    private route:Router,
    private fb:FormBuilder,
    private autoMlService:AutoMlService,
    private toast:ToastrService
  ){}

  loginForm!:FormGroup;

  ngOnInit(){
    this.initForm();
  }

  initForm(){
    this.loginForm = this.fb.group({
      username: new FormControl('',Validators.required),
      password: new FormControl('',Validators.required)
    })
  }

  login(){
    if(this.loginForm.valid){
      this.isLoading = true;
      this.autoMlService.loginEtl(this.loginForm.value)
      .pipe(
        finalize(()=>{
          this.isLoading = false
        })
      )
      .subscribe((res:any)=>{
        if(res.message ==='Login Successful'){
           this.toast.success(res.message);
           this.route.navigateByUrl('home');
           document.cookie = `token=${res.key};path=/;`;
           this.autoMlService.isAutoMl=false;
        }else{
          this.toast.error(res.error);
        }
      })

    }
  }
}
